import { render, staticRenderFns } from "./SpendingCard.vue?vue&type=template&id=a301e63e&scoped=true"
import script from "./SpendingCard.vue?vue&type=script&lang=js"
export * from "./SpendingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a301e63e",
  null
  
)

export default component.exports